import { updateRow } from "./table";

export const isEmailBcc = (to = [], cc = [], userEmail) => {
  // Handle null/undefined inputs
  const toEmails = to || [];
  const ccEmails = cc || [];

  // Helper function to extract email address from various formats
  const extractEmailAddress = (emailString) => {
    if (!emailString) return '';

    // Extract email from Name <email> format
    const nameEmailRegex = /^.+?\s*<([^>]*)>$/;
    const nameEmailMatch = emailString.match(nameEmailRegex);
    if (nameEmailMatch) {
      const [, email] = nameEmailMatch;
      return email.trim();
    }

    // Extract email from <email> format
    const bracketEmailRegex = /^<([^>]+)>$/;
    const bracketEmailMatch = emailString.match(bracketEmailRegex);
    if (bracketEmailMatch) {
      const [, email] = bracketEmailMatch;
      return email.trim();
    }

    // Plain email format
    return emailString.trim();
  };

  // Extract the user's email address
  const userEmailAddress = extractEmailAddress(userEmail);

  // Check if the user's email address is in the to or cc lists
  for (const email of toEmails) {
    if (extractEmailAddress(email) === userEmailAddress) {
      return false;
    }
  }

  for (const email of ccEmails) {
    if (extractEmailAddress(email) === userEmailAddress) {
      return false;
    }
  }

  return true;
}

export const htmlToPlainText = (html) => {
  return html.replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
};

export const parseEmailFormat = (emailString) => {
  if (!emailString) return '';

  // Case 3: Name <email> - return the name (only if name is not empty)
  const nameEmailRegex = /^(.+?)\s*<([^>]*)>$/;
  const nameEmailMatch = emailString.match(nameEmailRegex);
  if (nameEmailMatch) {
    const [, name] = nameEmailMatch;
    return name.trim();
  }

  // Case 2: <email> - return the email (no name available)
  const bracketEmailRegex = /^<([^>]+)>$/;
  const bracketEmailMatch = emailString.match(bracketEmailRegex);
  if (bracketEmailMatch) {
    const [, email] = bracketEmailMatch;
    return email.trim();
  }

  // Case 1: plain email - return as is
  return emailString.trim();
};

export const extractEmailAddress = (emailString) => {
  if (!emailString) return '';

  // Extract email from Name <email> format
  const nameEmailRegex = /^.+?\s*<([^>]*)>$/;
  const nameEmailMatch = emailString.match(nameEmailRegex);
  if (nameEmailMatch) {
    const [, email] = nameEmailMatch;
    return email.trim();
  }

  // Extract email from <email> format
  const bracketEmailRegex = /^<([^>]+)>$/;
  const bracketEmailMatch = emailString.match(bracketEmailRegex);
  if (bracketEmailMatch) {
    const [, email] = bracketEmailMatch;
    return email.trim();
  }

  // Plain email format
  return emailString.trim();
};

// lib/mail-utils.js
export const aggressiveEmailProcessor = (htmlContent) => {
  if (!htmlContent) return '';

  // Create a temporary DOM element to manipulate
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  // Remove all width attributes and styles
  const allElements = tempDiv.querySelectorAll('*');
  allElements.forEach(el => {
    // Remove width attributes
    el.removeAttribute('width');
    el.removeAttribute('min-width');

    // Remove problematic CSS properties
    if (el.style) {
      el.style.width = '';
      el.style.minWidth = '';
      el.style.maxWidth = '';
    }

    // Force tables to be responsive
    if (el.tagName === 'TABLE') {
      el.style.width = '100%';
      el.style.maxWidth = '100%';
      el.style.tableLayout = 'auto';
    }

    // Force table cells to wrap
    if (el.tagName === 'TD' || el.tagName === 'TH') {
      el.style.wordWrap = 'break-word';
      el.style.wordBreak = 'break-word';
      el.style.overflowWrap = 'break-word';
      el.style.whiteSpace = 'normal';
    }

    // Force images to be responsive
    if (el.tagName === 'IMG') {
      el.style.maxWidth = '100%';
      el.style.height = 'auto';
      el.style.width = 'auto';
    }
  });

  return tempDiv.innerHTML;
};

export const harmonizeEmail = (tableId, email, userEmail, activeBusiness, router) => {

  if ((extractEmailAddress(email.data.from) === userEmail) && userEmail) {
    const payload = {
      namespace: 'sent',
    }
    if (!email.namespace) {
      // console.log("Updating email namespace to sent");

      updateRow(tableId, email.id, payload, null, activeBusiness, null, router);
    }
  }
  else if (extractEmailAddress(email.data.from) !== userEmail) {
    const payload = {
      namespace: 'inbox',
    }
    if (!email.namespace) {
      // console.log("Updating email namespace to inbox");
      updateRow(tableId, email.id, payload, null, activeBusiness, null, router);
    }
  }

}

export const hasInvalidEmails = () => {
  const allEmails = [...recipients, ...ccRecipients, ...bccRecipients];
  return allEmails.some(email => !isValidEmail(email));
};